/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

import { validateValues, getDetailedRole } from '../../common/Utils';
import { updateField } from '../../../actions/BookingRequest';
import { TPaygrade, TRoleData, TBookingRequest, TServicesStructure } from '../../../types';

export type TCostExplanationBarProps = {
    bookingRequest: TBookingRequest;
    loadingPaygrade: boolean;
    paygrade: TPaygrade;
    roleData: TRoleData;
    servicesStructure: TServicesStructure;
    updateField: (id: string, value: number) => void;
};

class CostExplanationBar extends Component<TCostExplanationBarProps> {
    el: any;

    componentDidUpdate(prevProps: TCostExplanationBarProps) {
        const { client_pay_per_hour } = this.props.paygrade;
        const { number_of_freelancers, duration } = this.props.bookingRequest;
        const show = validateValues([
            client_pay_per_hour,
            number_of_freelancers,
            duration,
        ]);

        const { client_pay_per_hour: prev_client_pay_per_hour } =
            prevProps.paygrade;
        const {
            number_of_freelancers: prev_number_of_freelancers,
            duration: prev_duration,
        } = prevProps.bookingRequest;
        const prevShow = validateValues([
            prev_client_pay_per_hour,
            prev_number_of_freelancers,
            prev_duration,
        ]);

        if (prevShow !== show && document.body.clientWidth > 768)
            this.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    render() {
        const { client_pay_per_hour, base_client_pay_per_hour, skills_surcharge_per_hour } = this.props.paygrade;
        const { service, number_of_freelancers, duration } = this.props.bookingRequest;
        const show = validateValues([client_pay_per_hour, number_of_freelancers, duration]);
        const detailedRole = getDetailedRole(service, this.props.roleData, this.props.servicesStructure);
        const tooltipBase =
            <Tooltip id="tooltip-base">
                Base price per hour for a {detailedRole}
            </Tooltip>;
        const tooltipSkills =
            <Tooltip id="tooltip-skills">
                Extra surcharge for selected skills / box type
            </Tooltip>;

        return (
            <div
                ref={el => {this.el = el;}}
                className={`cost-explanation-container${show ? ' cost-explanation-container--show' : ''}`}
            >
                <div className="price-breakdown-bar">
                    <div className="price-breakdown-item price-breakdown-item--arrow-before">
                        Price breakdown
                    </div>
                </div>
                <div className="cost-explanation-bar">
                    <div className="inner-wrapper">
                        <div className="cost-explanation-item cost-explanation-item--total">
                            {this.props.loadingPaygrade ? (
                                <i className="icon icon-loading-1" />
                            ) : (
                                show && (
                                    <span className="cost-explanation-name">
                                        £{client_pay_per_hour.toFixed(2)} /h
                                    </span>
                                )
                            )}
                        </div>

                        <span className="item-separator--total" />
                        {!!base_client_pay_per_hour && (
                            <div className="cost-explanation-item cost-explanation-item--base">
                                <div className="cost-explanation-name">
                                    Base rate
                                    {show && (
                                        <OverlayTrigger
                                            trigger={['click', 'hover', 'focus']}
                                            placement="top"
                                            overlay={tooltipBase}
                                            rootClose={true}
                                        >
                                            <button
                                                type="button"
                                                className="information-button"
                                            >
                                                i
                                            </button>
                                        </OverlayTrigger>
                                    )}
                                </div>
                                {this.props.loadingPaygrade ? (
                                    <i className="icon icon-loading-1" />
                                ) : (
                                    show && (
                                        <span>£{base_client_pay_per_hour.toFixed(2)}{' '}/h</span>
                                    )
                                )}
                            </div>
                        )}
                        {!!skills_surcharge_per_hour && (
                            <span className="item-separator">+</span>
                        )}
                        {!!skills_surcharge_per_hour && (
                            <div className="cost-explanation-item cost-explanation-item--additional-skills">
                                <div className="cost-explanation-name">
                                    Additional skills surcharge
                                    {show && (
                                        <OverlayTrigger
                                            trigger={['click', 'hover', 'focus']}
                                            placement="top"
                                            overlay={tooltipSkills}
                                            rootClose={true}
                                        >
                                            <button
                                                type="button"
                                                className="information-button"
                                            >
                                                i
                                            </button>
                                        </OverlayTrigger>
                                    )}
                                </div>
                                {this.props.loadingPaygrade ? (
                                    <i className="icon icon-loading-1" />
                                ) : (
                                    show && (
                                        <span>£{skills_surcharge_per_hour.toFixed(2)}{' '}/h</span>
                                    )
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

type TState = {
    loading: { paygrade: boolean },
    requestData: {
        bookingRequest: TBookingRequest;
        roleData: TRoleData;
        paygrade: TPaygrade;
    },
    servicesStructure: TServicesStructure;
};

function mapStateToProps(state: TState) {
    return {
        bookingRequest: state.requestData.bookingRequest,
        loadingPaygrade: state.loading.paygrade,
        paygrade: state.requestData.paygrade,
        roleData: state.requestData.roleData,
        servicesStructure: state.servicesStructure,
    };
}

export default connect(mapStateToProps, { updateField })(CostExplanationBar);
